import { t as msg } from "./i18n";
import type { User } from "../../../../packages/shared/src/types";
export const profileName = (user: User) => user.displayName?.trim() || msg("Your account");
export const contactLabel = (user: User) => user.email?.toLowerCase().endsWith("@privaterelay.appleid.com")
  ? msg("Apple private email") : user.email || msg("A Promise Card account");
